import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function ProductShowcase() {
  return <section className="pt-12 md:pt-20 pb-6 md:pb-8 px-4 bg-brand-light" data-id="element-262">
      <div className="max-w-5xl mx-auto text-center" data-id="element-263">
        <div className="inline-flex items-center justify-center gap-2 bg-yellow-100 text-yellow-800 font-bold px-4 py-2 rounded-full mb-6" data-id="element-264">
          <span data-id="element-265">🏆</span> El sistema N°1 para docentes de Biología en Argentina
        </div>

        <h2 className="text-4xl md:text-6xl font-black text-brand-dark mb-4" data-id="element-266">
          🧬 BIOLOGÍA EN ACCIÓN
        </h2>
        <h3 className="text-3xl md:text-4xl font-extrabold text-brand-blue mb-8" data-id="element-267">
          MEGAPACK BIOLOGÍA EN ACCIÓN
        </h3>

        <p className="text-xl text-gray-700 max-w-3xl mx-auto mb-6 md:mb-12" data-id="element-268">
          6 Tomos organizados por año. +360 páginas con actividades
          secuenciadas, laboratorios reales y evaluaciones. 3 Bonos estratégicos
          de implementación. Todo alineado al Diseño Curricular.
        </p>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-6 md:mb-12" data-id="element-269">
          {['1°', '2°', '3°', '4°', '5°', '6°'].map(year => <div key={year} className="w-16 h-16 bg-white rounded-xl shadow-md flex items-center justify-center text-2xl font-black text-brand-blue border-2 border-brand-blue/10" data-id="element-270">
              {year}
            </div>)}
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-12 items-center" data-id="element-271">
          <div className="text-left bg-white p-5 md:p-8 rounded-2xl shadow-xl" data-id="element-272">
            <h4 className="text-2xl font-black text-brand-dark mb-4 md:mb-6 border-b pb-4" data-id="element-273">
              6 TOMOS COMPLETOS
            </h4>
            <ul className="space-y-4" data-id="element-274">
              {['Por año', 'Con actividades secuenciadas', 'Con laboratorios reales', 'Con evaluaciones'].map((item, i) => <li key={i} className="flex items-center gap-3 text-xl font-bold text-gray-800" data-id="element-275">
                  <CheckCircleIcon className="w-8 h-8 text-brand-green flex-shrink-0" data-id="element-276" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div data-id="element-277">
            <a href="#compra" className="block cursor-pointer transform hover:scale-[1.02] transition-transform duration-300" data-id="element-278">
              <img src="https://cdn.magicpatterns.com/uploads/pD6zazqouU3A1pvrCVRtRK/ChatGPT_Image_19_dic_2025,_07_13_20_p.m..png" alt="MegaPack Biología en Acción" className="w-full drop-shadow-2xl rounded-xl" data-id="element-279" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}